<template>
  <section id="health-report" class="card">
    <header class="card__head">
      <span class="step">1</span>
      <div>
        <strong>健康报告</strong>
        <p>整合设备检测、体检与问卷数据，生成最新健康基线</p>
      </div>
      <em>{{ member.hasReport ? '报告已生成' : '尚未生成报告' }}</em>
    </header>
    <div class="report">
      <div class="score-panel">
        <div class="ring"><span>{{ member.score }}</span></div>
        <div>
          <p>综合健康评分</p>
          <strong>{{ member.risk }}</strong>
          <em>更新于{{ member.updatedAt }}</em>
        </div>
      </div>
      <div class="indicators">
        <div v-for="item in member.indicators" :key="item.key || item.name" class="indicator">
          <div>
            <span>{{ item.name }}</span>
            <em :class="indicatorClass(item)">{{ item.noData ? '暂无数据' : (item.levelText || '--') }}</em>
          </div>
          <strong>{{ indicatorValue(item) }}</strong>
        </div>
      </div>
      <div class="conclusion">
        <p>AI健康结论</p>
        <span>{{ member.conclusion }}</span>
        <button type="button" :disabled="generating" @click="$emit('generate')">
          {{ generating ? '正在生成报告...' : (member.hasReport ? '重新生成报告' : '生成报告') }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
/** 健康报告：无报告时按钮为「生成报告」，noData 指标显示暂无数据，不当错误 */
import { indicatorClass } from '../helpers';

export default {
  name: 'HealthReport',
  props: {
    member: { type: Object, required: true },
    generating: { type: Boolean, default: false }
  },
  methods: {
    indicatorClass,
    indicatorValue(item) {
      if (item.noData) return '暂无数据';
      return `${item.value || '--'}${item.unit || ''}`;
    }
  }
};
</script>
